export function getCalendarRailBuildingOption(building) {
  return building ? { label: building.name, value: building.id } : null
}

export function toCalendarRailBuilding({ label, value }) {
  return { id: value, name: label }
}
